import { render } from "./App.vue?vue&type=template&id=f26728f6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f26728f6&lang=css"

import exportComponent from "/home/tyamada/ckan-ext-dev/yamanashi-dataplatform-admin-system-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__